
import { Tooltip } from "./utils/Tooltip";
import { eventDrag, eventDragLeave, eventDrop, eventPaste, notify, obtenerExtension, seleccionarArchivo, validarExtensionImagen, validarUrlVerImagen } from "../../utils/utils";
import {  useState } from "react";
import { CameraIcon, PaperClipIcon } from "@heroicons/react/outline";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const VistaArrastre = () => {
    return(
        <section className="w-full h-full border-[1px] border-dashed flex justify-center items-center">
            <span className="text-xl">Suelte su archivo aquí</span>
        </section>
    )
}


const VistaImagen = ({archivo, envioImagen, esBloqueo, showThumbs }) => {
    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3,
          slidesToSlide: 3 // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2,
          slidesToSlide: 2 // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
          slidesToSlide: 1 // optional, default to 1.
        }
    };
    return(
        <>
        {
            archivo.length > 0 ?
                <>
                    <Carousel
                        autoPlay={true}
                        showThumbs={showThumbs}
                        swipeable={true}
                        infiniteLoop={true}
                        showStatus={false}
                        draggable={false}
                        showDots={true}
                        responsive={responsive}
                        ssr={true} // means to render carousel on server-side.
                        infinite={true}
                        autoPlaySpeed={100}
                        keyBoardControl={true}
                        transitionDuration={500}
                        className={`carousel-root ${showThumbs ? 'with-thumbs' : 'without-thumbs'}`}
                    >
                        {
                            [
                                ...archivo.map((file,i) => {
                                    let src = !file.codigo ? URL.createObjectURL(file) : file.url//validarUrlVerImagen(file.url)
                                    return(
                                        <div key={file.identificador} className="flex h-full">
                                            <img src={src} key={(i + 1) + '_img'} style={{pointerEvents: 'auto'}} className="cursor-zoom-in" onClick={()=> window.open(src,'_blank')} alt=""></img>
                                            <i
                                                className={`fa fa-xmark left absolute top-0 right-[9%] text-[25px]
                                                text-red-700 hover:text-blue-900 z-50 cursor-pointer ${esBloqueo ? ' hidden ' : ''}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    envioImagen({tipo: 'Remover', carga: file })
                                                }}
                                            ></i>
                                        </div>
                                    )
                                }),
                                ...(
                                    !esBloqueo ?
                                        [
                                            <section
                                                key={'vista_agregar'}
                                                className="border-[1px] border-zinc-600 border-dashed w-full
                                                h-full flex flex-col justify-center items-center bg-zinc-800 z-50"
                                            >
                                                <span className="text-xl lg:text-xs text-center">Arrastrar hasta aquí o pegar su archivo</span>
                                                <label
                                                    htmlFor="file-imagen-carrusel"
                                                    key={'_labelIcono'}
                                                    className="lg:flex cursor-pointer"
                                                    data-tip={'addImg'} data-for={'addImg'}
                                                >
                                                    <img
                                                        src="https://cdn-icons-png.flaticon.com/512/2716/2716054.png"
                                                        className="w-[50px] h-[50px] cursor-pointer z-50"
                                                        alt=""
                                                    >
                                                    </img>
                                                    <input
                                                        key={'_inputImagenCarrusel'}
                                                        type="file" accept='image/*'
                                                        name="file-imagen-carrusel" id="file-imagen-carrusel"
                                                        className="inputfile inputfile-1" 
                                                        onChange={(e)=>{seleccionarArchivo(e, envioImagen, 'image', false)}} 
                                                    />
                                                </label>
                                            </section>
            
                                        ]
                                    : []
                                ) 
                            ]
                        }
                    </Carousel>

                </>
                
            :
                (
                    esBloqueo ? 
                        <></>
                    : 
                        <section className="border-[1px] border-zinc-600 border-dashed w-full h-full flex flex-col justify-center items-center bg-zinc-800">
                            <span className="text-xl lg:text-xs text-center">Arrastrar hasta aquí o pegar su imagen</span>
                            <label htmlFor="file-imagen" key={'_labelIcono'} className="lg:flex" data-tip={'addImg'} data-for={'addImg'}>
                                <img
                                    src="https://cdn-icons-png.flaticon.com/512/2716/2716054.png"
                                    className="w-[50px] h-[50px] cursor-pointer"
                                    alt=""
                                >
                                </img>
                                <input
                                    key={'_inputImagen'}
                                    type="file" accept='image/*'
                                    name="file-imagen" id="file-imagen"
                                    className="inputfile inputfile-1" 
                                    onChange={(e)=>{seleccionarArchivo(e, envioImagen, 'image', esBloqueo)}} 
                                />
                            </label>
                        </section>
                )  
        }
        </>

    )
}

export const ContenedorImagen = ({ archivo=[], envioImagen, esBloqueo=false, className, showThumbs=false}) => {
    const [ arrastrarImagen, setArrastrarImagen ] = useState(false);

    return(
        <section 
            className={`${className ? className : ''} w-full h-full rounded border border-zinc-600 bg-zinc-900 p-2 `}
            key={'_divContenedorPrincipal'}
            onPaste={(e) => eventPaste(e, envioImagen, 'image', esBloqueo)}
            onDragOver={(e) => eventDrag(e, setArrastrarImagen, esBloqueo)}
            onDrop={(e) => eventDrop(e, envioImagen, 'image', setArrastrarImagen, esBloqueo)}
            onDragLeave={() => eventDragLeave(setArrastrarImagen)}
        >
            {
                arrastrarImagen ? 
                    <VistaArrastre/>
                : 
                    <VistaImagen archivo={archivo} envioImagen={envioImagen} esBloqueo={esBloqueo} showThumbs={showThumbs}/>
            }
        </section>
    )
}